import './FilterCompositionMenuGroup.css';
export var emphasized = '_bzvdqt1-3-15-1';
export var label = '_bzvdqt2-3-15-1';
export var statement = '_bzvdqt0-3-15-1';
export var suffix = '_bzvdqt3-3-15-1';